import http from '@/utils/http';

export default {
	current: data => {
		return http({ url: '/api/admin/v1/feeConfig/current', data }).then(r => r);
	},
	list: data => {
		return http({ url: '/api/admin/v1/feeConfig/list', data }).then(r => r);
	},
	add: data => {
		return http({ url: '/api/admin/v1/feeConfig/add', data, tip: true }).then(r => r);
	},
};
